<template>
  <div class="spl-rac-number-modal">
    <form-button
      @onClick="goToUnionDatabase">
      Go to Union database on supply chain security
    </form-button>
    <form-button
      @onClick="addNewRacNumber">
      Add new RAC
    </form-button>
    <table>
      <thead>
        <tr class="spl-rac-number-modal__head">
          <th />
          <th
            v-for="(header, index) in tableFields"
            :key="'dashboardPrecariageHeader' + index">
            <span />
            {{ header.label }}
          </th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(dailyCargo, dailyCargoIndex) in dailyCargoRacNumbers"
          :key="'dailyCargoTable' + dailyCargoIndex">
          <td>
            <v-icon
              :color="isCopied(dailyCargo.RAC_Register_Nr) ? 'green darken-2' : ''"
              @click="copyRegisterNumber(dailyCargo.RAC_Register_Nr)">
              {{ isCopied(dailyCargo.RAC_Register_Nr) ? checkedIcon : icon }}
            </v-icon>
          </td>
          <td
            v-for="(field, fieldIndex) in tableFields"
            :key="'dashboardPrecariageField' + dailyCargoIndex + '.' + fieldIndex"
            class="spl-rac-number-modal__field">
            <span>
              {{ dailyCargo[field.name] }}
            </span>
          </td>
          <td>
            <form-button
              class="spl-daily-cargo-table__edit"
              @onClick="editData(dailyCargo)">
              <img src="../../../assets/icon-edit.svg">
            </form-button>
          </td>
          <td>
            <form-button
              class="spl-daily-cargo-table__edit"
              @onClick="removeData(dailyCargo)">
              <img src="../../../assets/icon-close.svg">
            </form-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import constants from '@/constants'
import Helpers from '@/helpers'
import { find } from 'lodash'

export default {
  name: 'RACNumbersModal',
  mixins: [Helpers],
  data () {
    return {
      isVisible: false,
      icon: 'mdi-content-copy',
      checkedIcon: 'mdi-check-circle',
      tableFields: [
        { name: 'RAC_Register_Nr', label: 'RAC_Register_Nr', type: 'String' },
        { name: 'RAC_Name', label: 'RAC_Name', type: 'String' },
        { name: 'RAC_Address', label: 'RAC_Address', type: 'String' },
        { name: 'RAC_Zip_Code', label: 'RAC_Zip_Code', type: 'String' },
        { name: 'RAC_City', label: 'RAC_City', type: 'String' },
        { name: 'RAC_Country', label: 'RAC_Country', type: 'String' },
        { name: 'RAC_Status', label: 'RAC_Status', type: 'String' }
      ],
      storedRacNumbers: this.getFromLocalstorage('clicked_rac_numbers') || []
    }
  },
  computed: {
    ...mapGetters('dailyCargo', ['dailyCargoRacNumbers'])
  },
  created () {
    this.loadDailyCargoRacNumbers()
    window.bus.$on('openRACNumbersModal', this.handleOpenRACNumbersModal)
  },
  beforeDestroy () {
    window.bus.$off('openRACNumbersModal', this.handleOpenRACNumbersModal)
  },
  methods: {
    ...mapActions('dailyCargo', ['loadDailyCargoRacNumbers', 'deleteRacNumber']),
    editData (dailyCargo) {
      this.$router.push({ name: 'daily-cargo-edit-rac-number', params: dailyCargo })
    },
    handleOpenRACNumbersModal () {
      this.isVisible = true
    },
    copyRegisterNumber (registerNumber) {
      const storedRacNumbers = this.getFromLocalstorage('clicked_rac_numbers') || []
      const foundStoredRacNumber = find(storedRacNumbers, { registerNumber: registerNumber })
      let updatedStoredRacNumbers = storedRacNumbers

      if (foundStoredRacNumber) {
        foundStoredRacNumber.date = new Date()
      } else {
        updatedStoredRacNumbers = [...storedRacNumbers, { registerNumber, date: new Date() }]
      }

      localStorage.setItem('clicked_rac_numbers', JSON.stringify(updatedStoredRacNumbers))
      this.storedRacNumbers = updatedStoredRacNumbers
      navigator.clipboard.writeText(registerNumber)
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
    },
    goToUnionDatabase () {
      window.open(constants.EXTERNAL_LINKS.Daily_Cargo_Union_DB, '_blank')
    },
    addNewRacNumber () {
      this.$router.push('/daily-cargo-edit-rac-number')
    },
    removeData (dailyCargo) {
      if (window.confirm('Are you sure you want to delete this Rac Number?')) {
        this.deleteRacNumber(dailyCargo).then(() => {
          this.loadDailyCargoRacNumbers()
          this.$forceUpdate()
        })
      }
    },
    isCopied (racNumber) {
      const foundStoredRacNumber = find(this.storedRacNumbers, { registerNumber: racNumber })
      if (!foundStoredRacNumber) return false
      const copiedDate = new Date(foundStoredRacNumber.date)
      const today = new Date()
      const diffTime = Math.abs(today - copiedDate)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays < 2
    }
  }
}
</script>

<style lang="scss">
@import '../../../variables.scss';

.spl-rac-number-modal {
  &__edit {
      background-color: $footerButtonYellow;
      color: $yellowButtonLabel;
      height: 24px;
      margin: 0 0 0 0 !important;
    }

    width: 100%;
    height: calc(100vh - 205px);
    padding-bottom: 20px;
    overflow: auto;

    &__buttons {
      display: grid;
      grid-template-columns: 16% 16% 16% 16% 16% 16%;
      width: 75%;
      float: right;
      div {
        margin-bottom: 5px;
      }
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {
      tr {
        background-color: $tableRowBackgroundColor;
        &:nth-child(even) {
          background: $tableHeaderBackgroundColor;
        }
      }
      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }
      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }
      td:hover {
        background-color: $tableColumnBackgroundColorHover;
      }
      td:first-child {
        border-left-width: 1px;
      }
    }
}
</style>
